import type { ParticipantId } from "../types/common";
import type { EntityBody } from "../types/entity";

export function getEntityById(
  entities: ReadonlyArray<EntityBody>,
  entityId: string,
): EntityBody | undefined {
  return entities.find((entity) => entity.id === entityId);
}

export function countRemaining(
  entities: ReadonlyArray<EntityBody>,
  participantId: ParticipantId,
): number {
  return entities.filter(
    (entity) => !entity.eliminated && entity.owner === participantId,
  ).length;
}
